<div class="payment-success">
  <div class="card">
    <div class="icon">✅</div>
    <h2>Payment Successful!</h2>
    <p>Thank you for your purchase. Your order has been confirmed.</p>

    <!--
    <div class="order-summary">
      <h3>Order Summary</h3>
      <p><strong>Order ID:</strong> #DEL-1023</p>
      <p><strong>Amount Paid:</strong> €249.00</p>
      <p><strong>Payment Method:</strong> Credit Card (Visa)</p>
    </div>
    <button routerLink="/" class="btn-home">Back to Home</button>
    -->
  </div>
</div>
